module.exports = __webpack_public_path__ + "static/media/Certificated-logo.3d7f4e14.jpg";